module.exports = __webpack_public_path__ + "static/media/eyelashes01.db7bd7b1.jpg";